<template>
	<header class="layout-header">
		<b-container>
			<div class="layout-header--row">
				<div class="logo">
					<a href="/">
						<img src="/img/logo_claim.svg" alt="skilldoo - let your skills doo"/>
					</a>
				</div>
				<div v-if="!hideNav" class="layout-header--row-navigations">
					<nav class="left">
						<ul>
							<!--<li>
								<a href="/info/wie-funktioniert-es" target="_blank">Wie funktioniert's?</a>
							</li>-->
							<li v-if="isNavTypeApplicant">
								<a href="/info/faq" target="_blank">FAQs</a>
							</li>
							<li v-if="isNavTypeCustomer">
								<a href="/info/preise" target="_blank">Preise</a>
							</li>
							<li v-if="isNavTypeCustomer">
								<a href="/info/faq-kunde" target="_blank">FAQs</a>
							</li>
							<li v-if="authLoaded">
								<a v-if="!isLoggedIn" href="/auth/login">Login</a>
								<a v-else-if="application" href="/kandidat/profil/jobs">{{ application.firstName }}</a>
								<a v-else-if="customer" href="/kundenbereich/jobs">{{ customer.firstName }}</a>
							</li>
						</ul>
					</nav>
					<template v-if="!isNavTypeLogin">
						<nav v-if="isNavTypeApplicant && authLoaded && !isLoggedIn" class="right">
							<ul>
								<li>
									<a href="/mitarbeiterfinden">
										skilldoo für Arbeitgeber
										<Icon icon="arrow-north-east"/>
									</a>
								</li>
							</ul>
						</nav>
						<nav v-if="isNavTypeCustomer && authLoaded && !isLoggedIn" class="right">
							<ul>
								<li>
									<a href="/jobfinden">
										skilldoo für Arbeitnehmer
										<Icon icon="arrow-north-east"/>
									</a>
								</li>
							</ul>
						</nav>
					</template>
				</div>
			</div>
		</b-container>
	</header>
</template>

<script>
import Loading from "@/vue/common/Loading";
import {mapGetters, mapState} from "vuex";
import Icon from "@/vue/icon/Icon";

const NAVIGATION_TYPE__LOGIN = 'login';
const NAVIGATION_TYPE__APPLICANT = 'applicant';
const NAVIGATION_TYPE__CUSTOMER = 'customer';

export default {

	components: {
		Loading,
		Icon,
	},

	props: {
		hideNav: {
			type: Boolean,
			required: true,
		},
		navType: {
			type: String,
			required: false
		}
	},

	data ()
	{
		return {
			loading: false,
		};
	},

	computed: {
		...mapState('auth', [
			'customer',
			'application',
		]),
		...mapState('auth', {
			authLoaded: 'loaded'
		}),
		...mapGetters('auth', {
			isLoggedIn: 'isLoggedIn'
		}),
		isNavTypeLogin ()
		{
			return this.navType === NAVIGATION_TYPE__LOGIN;
		},
		isNavTypeApplicant ()
		{
			return this.navType === NAVIGATION_TYPE__APPLICANT;
		},
		isNavTypeCustomer ()
		{
			return this.navType === NAVIGATION_TYPE__CUSTOMER;
		},
	},
}
</script>
